import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

export const tradeRecommendationService = {
  // Get all trade recommendations
  // getAllTradeRecommendations: async (limit, offset) => {
  //   try {
  //     const response = await api.get(
  //       `${API_ENDPOINTS.TRADERECOMMENDATIONS}?limit=${limit}&offset=${offset}`,
  //       {
  //         limit,
  //         offset,
  //       }
  //     );
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },

  // getAllTradeRecommendations: async (limit, offset, searchTerm = '') => {
  //   try {
  //     // Build query params safely
  //     const params = new URLSearchParams({
  //       limit: limit.toString(),
  //       offset: offset.toString(),
  //       ...(searchTerm.trim() && { search: searchTerm.trim() }) // only add if not empty
  //     });

  //     const response = await api.get(
  //       `${API_ENDPOINTS.TRADERECOMMENDATIONS}?${params}`
  //     );

  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },

  getAllTradeRecommendations: async (limit, offset, filters = {}) => {
    try {
      const params = new URLSearchParams();

      // Pagination
      params.append('limit', limit.toString());
      params.append('offset', offset.toString());

      // Search term
      if (filters.searchTerm?.trim()) {
        params.append('search', filters.searchTerm.trim());
      }

      // Status filter
      if (filters.status) {
        params.append('status', filters.status);
      }

      // Type filter
      if (filters.type) {
        params.append('type', filters.type);
      }

      // Created date range
      if (filters.createdFrom) {
        params.append('createdFrom', filters.createdFrom);
      }
      if (filters.createdTo) {
        params.append('createdTo', filters.createdTo);
      }

      // Exit date range
      if (filters.exitFrom) {
        params.append('exitFrom', filters.exitFrom);
      }
      if (filters.exitTo) {
        params.append('exitTo', filters.exitTo);
      }

      // User ID filter
      if (filters.userId?.trim()) {
        params.append('userId', filters.userId.trim());
      }

      // Track only filter
      if (filters.trackOnly && filters.trackOnly !== '') {
        params.append('trackOnly', filters.trackOnly);
      }

      const response = await api.get(
        `${API_ENDPOINTS.TRADERECOMMENDATIONS}?${params.toString()}`
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  getScriptTypes: async () => {
    try {
      const response = await api.get(
        API_ENDPOINTS.SCRIPT_TYPE
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get trade recommendation by ID
  getTradeRecommendationById: async (id) => {
    try {
      const response = await api.get(
        API_ENDPOINTS.TRADERECOMMENDATIONS_BY_ID(id)
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Create new trade recommendation
  createTradeRecommendation: async (tradeRecommendationData) => {
    try {
      const response = await api.post(
        API_ENDPOINTS.TRADERECOMMENDATIONS,
        tradeRecommendationData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update trade recommendation
  updateTradeRecommendation: async (id, tradeRecommendationData) => {
    try {
      const response = await api.put(
        API_ENDPOINTS.TRADERECOMMENDATIONS_BY_ID(id),
        tradeRecommendationData
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete trade recommendation
  deleteTradeRecommendation: async (id) => {
    try {
      const response = await api.delete(
        API_ENDPOINTS.TRADERECOMMENDATIONS_BY_ID(id)
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Search trade recommendations
  searchTradeRecommendations: async (query, filters = {}) => {
    try {
      const params = { search: query, ...filters };
      const response = await api.get(API_ENDPOINTS.TRADERECOMMENDATIONS, {
        params,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get recommendations by stock (optional - add if needed)
  getRecommendationsByStock: async (stockId) => {
    try {
      const response = await api.get(
        `${API_ENDPOINTS.TRADERECOMMENDATIONS}/stock/${stockId}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get recommendations by status (optional - add if needed)
  getRecommendationsByStatus: async (status) => {
    try {
      const params = { status };
      const response = await api.get(API_ENDPOINTS.TRADERECOMMENDATIONS, {
        params,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get recommendations by risk level (optional - add if needed)
  getRecommendationsByRiskLevel: async (riskLevel) => {
    try {
      const params = { riskLevel };
      const response = await api.get(API_ENDPOINTS.TRADERECOMMENDATIONS, {
        params,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
